import { render, staticRenderFns } from "./PermissionsByProfile.vue?vue&type=template&id=143502c3&scoped=true"
import script from "./PermissionsByProfile.vue?vue&type=script&lang=js"
export * from "./PermissionsByProfile.vue?vue&type=script&lang=js"
import style1 from "./PermissionsByProfile.vue?vue&type=style&index=1&id=143502c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143502c3",
  null
  
)

export default component.exports